import { render, staticRenderFns } from "./OrderMailTargetStore.vue?vue&type=template&id=2481df88&"
import script from "./OrderMailTargetStore.vue?vue&type=script&lang=js&"
export * from "./OrderMailTargetStore.vue?vue&type=script&lang=js&"
import style0 from "./OrderMailTargetStore.vue?vue&type=style&index=0&id=2481df88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports